// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"127":"b545c8a42a832fcf","3360":"b545c8a42a832fcf","5405":"b545c8a42a832fcf"}[chunkId] + ".css";
};